import type { ThemingConfig } from "@chakra-ui/react"

export const textStyles = {
  400: {
    value: {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "1.5rem",
    },
  },
  500: {
    value: {
      fontSize: "1rem",
      fontWeight: 500,
      lineHeight: "1.5rem",
    },
  },
  600: {
    value: {
      fontSize: "1.25rem",
      fontWeight: 600,
      lineHeight: "1.75rem",
    },
  },
  625: {
    value: {
      fontSize: "0.625rem",
      fontWeight: 400,
      lineHeight: "0.875rem",
    },
  },
  625100: {
    value: {
      fontSize: "0.625rem",
      fontWeight: 400,
      lineHeight: "1rem",
    },
  },
  8125: {
    value: {
      fontSize: "0.8125rem",
      fontWeight: 400,
      lineHeight: "1rem",
    },
  },
  8125500: {
    value: { fontSize: "0.8125rem", fontWeight: 500, lineHeight: "1rem" },
  },
  8125700: {
    value: {
      fontSize: "0.8125rem",
      fontWeight: 700,
      lineHeight: "1rem",
    },
  },
  875: {
    value: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: "1.25rem",
    },
  },
  87500: {
    value: {
      fontSize: "0.875rem",
      fontWeight: 500,
      lineHeight: "1.25rem",
    },
  },
  875700: {
    value: {
      fontSize: "0.875rem",
      fontWeight: 700,
      lineHeight: "1.25rem",
    },
  },
  1500: {
    value: {
      fontSize: "1rem",
      fontWeight: 500,
      lineHeight: "1.5rem",
    },
  },
  1600: {
    value: {
      fontSize: "1rem",
      fontWeight: 600,
      lineHeight: "1.5rem",
    },
  },
  1: {
    value: {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "1.5rem",
    },
  },
  1125: {
    value: {
      fontSize: "1.125rem",
      fontWeight: 400,
      lineHeight: "1.75rem",
    },
  },
  1125500: {
    value: {
      fontSize: "1.125rem",
      fontWeight: 500,
      lineHeight: "1.75rem",
    },
  },
  1125700: {
    value: {
      fontSize: "1.125rem",
      fontWeight: 700,
      lineHeight: "1.75rem",
    },
  },
  125: {
    value: { fontSize: "1.25rem", fontWeight: 600, lineHeight: "1.75rem" },
  },
  125400: {
    value: {
      fontSize: "1.25rem",
      fontWeight: 400,
      lineHeight: "1.75rem",
    },
  },
  125500: {
    value: {
      fontSize: "1.25rem",
      fontWeight: 500,
      lineHeight: "1.75rem",
    },
  },
  175: {
    value: {
      fontSize: "1.75rem",
      fontWeight: 600,
      lineHeight: "2.25rem",
    },
  },
  175500: {
    value: {
      fontSize: "1.75rem",
      fontWeight: 500,
      lineHeight: "2.25rem",
    },
  },
  225: {
    value: { fontSize: "2.25rem", fontWeight: 500, lineHeight: "2.75rem" },
  },
  225600: {
    value: {
      fontSize: "2.25rem",
      fontWeight: 600,
      lineHeight: "2.75rem",
    },
  },
  1700: {
    value: {
      fontSize: "1rem",
      fontWeight: 700,
      lineHeight: "1.5rem",
    },
  },
  15: {
    value: {
      fontSize: "1.5rem",
      fontWeight: 400,
      lineHeight: "2.25rem",
    },
  },
  15600: {
    value: {
      fontSize: "1.5rem",
      fontWeight: 600,
      lineHeight: "2.25rem",
    },
  },
  325: {
    value: {
      fontSize: "3.25rem",
      fontWeight: 600,
      lineHeight: "3.75rem",
      letterSpacing: "-0.0975rem",
    },
  },
  325700: {
    value: {
      fontSize: "3.25rem",
      fontWeight: 700,
      lineHeight: "3.75rem",
      letterSpacing: "-0.0975rem",
    },
  },
  425: {
    value: {
      fontSize: "4.25rem",
      fontWeight: 600,
      lineHeight: "4.75rem",
      letterSpacing: "-0.0975rem",
    },
  },
  75: {
    value: {
      fontSize: "0.75rem",
      fontWeight: 400,
      lineHeight: "1rem",
    },
  },
  28125: {
    value: {
      fontSize: "2.8125rem",
      fontWeight: 600,
      lineHeight: "3.25rem",
    },
  },
  2: {
    value: {
      fontSize: "2rem",
      fontWeight: 600,
      lineHeight: "2.5rem",
    },
  },
} satisfies ThemingConfig["textStyles"]
